import { useTranslation } from "react-i18next";

import { useChannel } from "../hooks/useChannel";
import { useChannelInvoices } from "../hooks/useChannelInvoices";
import { InvoicedEntityPage } from "./components/InvoicedEntityPage";

import { ROUTES } from "@/constants/routes";
import { useChannelInvoiceTableColumns } from "@/lib/tableColumns/useChannelInvoiceTableColumns";
import { ChannelInvoiceType } from "@/types/response/ChannelInvoiceType";
import { ChannelType } from "@/types/response/ChannelType";

const InvoicedChannelsPage = () => {
  const { t } = useTranslation();

  return (
    <InvoicedEntityPage<ChannelInvoiceType, ChannelType>
      entityIdParam="channelId"
      routeSegment={ROUTES.channels}
      apiEndpointBase="Channels"
      useInvoices={useChannelInvoices}
      useEntity={useChannel}
      useTableColumns={useChannelInvoiceTableColumns}
      getColumnsFromResult={(result) => {
        const columns = result.channelInvoiceTableColumns;
        return Array.isArray(columns) ? columns : [];
      }}
      getRowId={(row) => row.clientId2}
      locationStateKey="channelName"
      breadcrumb={{
        label: t("common.channel"),
        listLabel: t("common.channels"),
      }}
      entityNameKey="name"
      mapInvoiceToRequest={(invoice) => ({
        amount: invoice.amount,
        channelId: invoice.channelId,
        clientId2: invoice.clientId2,
      })}
      editableField="amount"
    />
  );
};

export default InvoicedChannelsPage;
